import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_444: DocMigration = {
  maxSchemaVersion: "0.0.444",
  description: "Delete all ROOF_DORMER_* categories from view templates and view template override categories",
  apply(json: any) {
    if (json.viewTemplates) {
      for (const viewTemplateId in json.viewTemplates) {
        const categoriesNew: string[] = [];
        const viewTemplate = json.viewTemplates[viewTemplateId];
        for (const category of viewTemplate.categories) {
          switch (category) {
            case "ROOF_DORMER_FRAMING":
            case "ROOF_DORMER_OVERHANG_DIM_LABEL":
            case "ROOF_DORMER_OVERHANG_DIM_LINE":
            case "ROOF_DORMER_OVERHANG_DIM_LINEWORK":
            case "ROOF_DORMER_OVERHANG_DIM_TICK":
            case "ROOF_DORMER_OVERHANG_DIM_WITNESS":
            case "ROOF_DORMER_OVERHANG_DIM_GROUP":
              break;
            default: {
              categoriesNew.push(category);
              break;
            }
          }
        }

        viewTemplate.categories = categoriesNew;
      }
    }

    return json;
  },
};

export default migration_0_0_444;
